import type { ClientGroup } from "@stockline/shared/types/crm/client-group"
import type { OfflineResourceConfig } from "../../../types"
import { CLIENT_GROUP_TABLE } from "./db"

export const clientGroupConfig: OfflineResourceConfig<ClientGroup> = {
  name: "client-groups",
  endpoints: {
    full: "/api/v2/client-groups",
    delta: "/api/v2/client-groups/changes",
    // Full CRUD on V2 — push-batch handler at POST /changes accepts the
    // standard `{ changes: [...], clientSyncId }` envelope and publishes
    // `client-group.{created,updated,deleted}` events on success.
    push: "/api/v2/client-groups/changes",
  },
  tableName: CLIENT_GROUP_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
